import { Global } from '@emotion/react';

export const GlobalStyles = () => (
  <Global
    styles={{
      // button: {
      // 	padding: "12px 16px",
      // },
      '.ant-btn-primary': {
        boxShadow: 'none',
      },
      strong: {
        // fontWeight: '500 !important',
        fontFamily:
          "ABBvoiceCNSG-Regular, 'Hiragino Sans GB', 'WenQuanYi Micro Hei', sans-serif, serif !important",
        wordBreak: 'break-all',
      },
      /* 表格行 hover/选中见 global.css（需高于 antd 内联样式优先级） */
      '.ant-table-wrapper .ant-table-tbody > tr > td': {
        color: 'rgba(31, 31, 31, 1) !important',
        fontWeight: '400',
        wordBreak: 'break-all',
        fontSize: '14px',
      },
      table: {
        thead: {
          tr: {
            th: {
              borderBottom: '2px solid rgba(31, 31, 31, 1) !important',
              background: '#fff !important',
              fontSize: '14px !important',
              fontWeight: '500 !important',
            },
            '.ant-table-cell': {
              '&:before': {
                display: 'none',
              },
            },
          },
        },
      },
      '.ant-picker-range-separator': {
        padding: '0 16px 0 0 !important',
      },
      '.ant-picker': {
        borderWidth: '2px !important',
      },
      // Card
      '.ant-card-bordered': {
        border: 'none',
      },
      '.ant-card-head': {
        fontWeight: '500 !important',
        // borderBottom: 'none !important',
        borderColor: '#1f1f1f!important',
        '.ant-card-head-title': {
          fontSize: '16px',
        },
      },
      '.ant-input': {
        borderWidth: 2,
      },
      '.ant-input:focus': {
        borderInlineEndWidth: '2px',
      },
      '.ant-input:hover': {
        borderInlineEndWidth: '2px',
      },
      '.ant-btn-link': {
        padding: 0,
      },
      '.ant-select-selector': {
        borderWidth: '2px !important',
      },
      '.ant-input-number-group-addon': {
        borderWidth: '2px !important',
      },
      '.ant-input-number': {
        borderWidth: '2px !important',
      },
      '.ant-modal:not(.ant-modal-confirm)': {
        '.ant-modal-content': {
          borderRadius: 0,
        },
        '.ant-modal-close': {
          '.ant-modal-close-icon': {
            color: '#1F1F1F',
          },
        },
        '.ant-modal-title': {
          marginBottom: 16,
        },
      },
      '.ant-pagination ': {
        '.ant-pagination-item-active': {
          border: 'none !important',
          borderBottom: '2px solid rgba(31, 31, 31, 1) !important',
          borderRadius: 0,
        },
      },
      '.ant-modal-confirm-warning': {
        '.anticon-warning svg': {
          marginTop: '3px',
          fontSize: '16px',
        },
        '.ant-modal-content': {
          borderTop: '4px solid #FFA200',
          borderRadius: 0,
        },
      },
      '.ant-modal-confirm': {
        '.ant-modal-confirm-title': {
          lineHeight: 1,
        },
      },
      '.ant-modal-confirm-confirm': {
        '.ant-modal-content': {
          borderTop: '4px solid rgba(0, 81, 255, 1)',
          borderRadius: 0,
        },
      },
      '.ant-modal-confirm-error': {
        '.ant-modal-content': {
          borderTop: '4px solid #ff000f',
          borderRadius: 0,
        },
      },
      '.ant-input-suffix': {
        '.anticon-search': {
          color: '#696969',
        },
      },
      form: {
        '.ant-form-item ': {
          '.ant-row': {
            '.ant-form-item-label': {
              color: '#1F1F1F',
              fontWeight: 500,
            },
          },
        },
      },
      '.ant-switch[aria-checked="false"]': {
        '.ant-switch-inner-checked': {
          opacity: 0,
        },
        '.ant-switch-inner-unchecked': {
          position: 'relative',
          left: '-20px',
          color: 'rgb(198 198 198)',
          top: '-4px',
        },
      },
      '.ant-switch[aria-checked="true"]': {
        '.ant-switch-inner-unchecked': {
          opacity: 0,
        },
        '.ant-switch-inner-checked': {
          position: 'relative',
          left: '20px',
          color: '#3366FF',
          top: '0px',
        },
      },
      '.ant-tabs': {
        // '.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn': {
        //   color: '#000 !important',
        // },
        '.ant-tabs .ant-tabs-tab-btn': {
          color: '#696969 !importent',
          fontWeight: '400 !importent',
        },
        '.ant-tabs-nav': {
          margin: '0px !importent',
        },
      },
      '.ant-input-affix-wrapper': {
        borderWidth: '2px !important',
      },
      '.ant-select': {
        borderWidth: '2px !important',
      },
      '.ant-menu .ant-menu-submenu-selected >.ant-menu-submenu-title': {
        color: 'rgba(31, 31, 31, 1)',
      },
      '.ant-menu .ant-menu-item-selected': {
        color: 'rgba(31, 31, 31, 1)',
        background: 'rgba(245, 245, 245, 1) !important',
      },
      '.ant-menu-item-selected': {
        backgroundColor: '#f0f4ff !important',
      },
      '.ant-menu-light.ant-menu-inline .ant-menu-sub.ant-menu-inline': {
        background: 'none !important',
      },
      '.ant-list-split .ant-list-item:last-child': {
        borderBlockEnd: '1px solid rgba(5, 5, 5, 0.06)',
      },
      '.ant-picker-time-panel-column': {
        '&::-webkit-scrollbar': {
          width: '4px !important',
        },
      },
      '.ant-pro-layout': {
        '.ant-pro-layout-content': {
          paddingBlock: '0',
          paddingInline: '0',
        },
      },
      // bpmn
      '.bjs-powered-by': {
        display: 'none',
      },
      // layout
      '.ant-layout-header .ant-menu': {
        // display: 'flex',
        // justifyContent: 'center',
        '.ant-menu-item': {
          height: '54px',
          lineHeight: '54px',
          padding: '0',
          margin: '0 16px',
        },
        '.ant-menu-overflow-item': {
          height: '54px',
          lineHeight: '54px',
          padding: '0',
          margin: '0 16px',
        },
        '.ant-menu-item-selected,.ant-menu-submenu-selected': {
          backgroundColor: 'transparent !important',
          // borderBottom: '4px solid rgba(31, 31, 31, 1)',
          // borderRadius: 0,
          '.ant-menu-title-content': {},
        },
      },
      '.ant-pro-top-nav-header-menu': {
        paddingBlock: '0px !important',
      },
      // '.ant-pro-top-nav-header-menu': {
      //   paddingBlock: '0'
      // },
      // ".ant-pro-base-menu-inline-submenu-has-icon >.ant-menu-sub": {
      //   paddingInlineStart: '0px'
      // },
      // ".ant-menu.ant-menu-inline .ant-menu-item": {
      //   margin: '4px 0px',
      //   width: '100%',
      //   height: '56px',
      // },
      // ".ant-pro-base-menu-inline-menu-item": {
      //   ".ant-menu-title-content": {
      //     paddingLeft: '16px'
      //   }
      // },
      // ".ant-menu-inline.ant-menu-root .ant-menu-submenu-title": {
      //   margin: '4px 0px',
      //   width: '100%',
      //   ".ant-menu-submenu-arrow": {
      //     left: '16px'
      //   },
      //   ".ant-menu-title-content": {
      //     paddingLeft: '16px'
      //   }
      // }
      // typography
      '.ant-typography.ant-typography-secondary': {
        color: 'rgba(105, 105, 105, 1)',
      },
      '.ant-tree-checkbox-indeterminate': {
        '.ant-tree-checkbox-inner': {
          backgroundColor: 'rgb(0,0,0) !important',
          '&:after': {
            height: '2px !important',
            backgroundColor: 'white !important',
          },
        },
      },
    }}
  />
);
